// backup of the storee.js file
import Vue from 'vue'
import Vuex from 'vuex'
//
Vue.use(Vuex)
//


export default new Vuex.Store({
    state: {
        basket: {
            photofixr: {
                total: 0
            },
            instantPrint: {
                total: 0
            },
            directmailr: {
                total: 0
            },
            totalOrders: 0,
            subtotal: 0.00
        },
        userContext: {}

    },

    getters: {
        getPhotofixrTotal: state => {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }

            // if (state.basket.photofixr.total !== JSON.parse(window.sessionStorage.getItem('_uploadedOrders'))) {
            return state.basket
            // }
        },
        getInstantPrintTotal: state => {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            return state.basket.instantPrint.total
        },
        // getOrderValue: state => {
        //     if (window.sessionStorage.getItem('_basket') !== null) {
        //         state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
        //     }
        //
        //
        //     // console.log(JSON.parse(window.sessionStorage.getItem('_printJob')).netTotalPrice)
        //
        //
        //     return state.basket.subtotal
        // },
        getOrderTotal: state => {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            console.log(state.basket.totalOrders)
            return state.basket.totalOrders
        },
        getCookies: state => {
            state.userContext = {};
            console.log('in auth created')
            console.log(document.cookie.split(";"))
            let authCookie = document.cookie.split(";");

            for (let id in authCookie) {
                console.log(id)
                let cookie = authCookie[id].split("=");
                console.log(cookie)
                state.userContext[cookie[0].trim()] = cookie[1];
            }

            return state.userContext;


            // }
        },
    },
    mutations: {
        incrementPhotofixrTotal(state, payload) {
            console.log('Photofixr order length')
            console.log(payload)
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }

            console.log(payload)

            if (typeof payload.photofixr !== 'undefined') {
                state.basket.photofixr.total = payload.photofixr
            }

            if (typeof payload.instantPrint !== 'undefined') {
                state.basket.instantPrint.total = payload.instantPrint
            }

            if (typeof payload.directmailr !== 'undefined') {
                state.basket.directmailr.total = payload.directmailr
            }

            // state.basket.photofixr.total = payload
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        decrementPhotofixrTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.photofixr.total--
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        wipePhotofixrTotal(state) {

            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.photofixr.total = 0
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))

        },
        incrementInstantPrintTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.instantPrint.total = 1
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        decrementInstantPrintTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.instantPrint.total--
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        wipeInstantPrintTotal(state) {

            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.instantPrint.total = 0
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))

        },
        incrementDirectmailrTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.directmailr.total = 1
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        decrementDirectmailrTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.directmailr.total--
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        wipeDirectmailrTotal(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }
            state.basket.directmailr.total = 0
            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))
        },
        calculateBasketSummary(state) {
            if (window.sessionStorage.getItem('_basket') !== null) {
                state.basket = JSON.parse(window.sessionStorage.getItem('_basket'))
            }

            state.basket.totalOrders = state.basket.photofixr.total + state.basket.instantPrint.total + state.basket.directmailr.total;
            console.log('total orders ' + state.basket.totalOrders)
            state.basket.subtotal = '';

            window.sessionStorage.setItem('_basket', JSON.stringify(state.basket))

        },
    },

    actions: {
        incrementPhotofixrTotal: async (state, payload) => {
            state.commit('incrementPhotofixrTotal', payload);
            state.commit('calculateBasketSummary');
        },
        decrementPhotofixrTotal: async (state) => {
            state.commit('decrementPhotofixrTotal');
            state.commit('calculateBasketSummary');
        },
        wipePhotofixrTotal: async (state) => {
            state.commit('wipePhotofixrTotal');
            state.commit('calculateBasketSummary');
        },
        incrementInstantPrintTotal: async (state) => {
            state.commit('incrementInstantPrintTotal');
            state.commit('calculateBasketSummary');
        },
        decrementInstantPrintTotal: async (state) => {
            state.commit('decrementInstantPrintTotal');
            state.commit('calculateBasketSummary');
        },
        wipeInstantPrintTotal: async (state) => {
            state.commit('wipeInstantPrintTotal');
            state.commit('calculateBasketSummary');
        },
        incrementDirectmailrTotal: async (state) => {
            state.commit('incrementDirectmailrTotal');
            state.commit('calculateBasketSummary');
        },
        decrementDirectmailrTotal: async (state) => {
            state.commit('decrementDirectmailrTotal');
            state.commit('calculateBasketSummary');
        },
        wipeDirectmailrTotal: async (state) => {
            state.commit('wipeDirectmailrTotal');
            state.commit('calculateBasketSummary');
        },
        calculateBasketSummary: async (state) => {
            state.commit('calculateBasketSummary');
        }

    }
})
//
// export default new Vuex.Store({
//     state,
//     getters,
//     mutations,
//     actions
// })
